<template>
  <section>
    <div class="action-buttons">
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-green is-medium"
          id="clear"
          @click="validateModifications"
          :disabled="!modifiedRows.length"
        >
          <span>
            <i class="fal fa-check"></i> Valider les modifications
          </span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="cancelModifications"
          :disabled="!modifiedRows.length"
        >
          <span>
            <i class="fal fa-times"></i> Annuler les modifications
          </span>
        </button>
      </div>
    </div>

    <b-table
      class="b-table"
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      :mobile-cards="false"
    >
      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >{{ props.column.label }}</b-tooltip>
      </template>
      <template slot-scope="props">

        <b-table-column
          meta="Version du Weezy"
          v-if="isAdmin"
          field="version"
          label="Version"
          :centered="true"
          :sortable="true"
        >
          {{props.row.version}}
        </b-table-column>

        <b-table-column
          meta="Nom du Weezy"
          field="name"
          label="Nom"
          :centered="true"
          :sortable="true"
        >
          <span class="tag is-primary is-medium">
            <input
              class="b-text-input"
              v-model="props.row.name"
              @input="toggleModified(props.row)"
              placeholder="Entrer un Nom"
            >
          </span>
        </b-table-column>

        <b-table-column
          meta="État actif/inactif du Weezy"
          field="is_active"
          label="Actif"
          :centered="true"
          :sortable="true"
          :custom-sort="sortByActive"
        >
          <b-switch
            type="is-success"
            v-model="props.row.is_active"
            @input="toggleModified(props.row)"
          ></b-switch>
        </b-table-column>

        <b-table-column
          meta="Campagne à laquelle le Weezy est rattaché"
          field="campaign_id"
          label="Campagne"
          :centered="true"
          :sortable="true"
        >
          <b-select
            placeholder="Choisir la Campagne"
            v-model="props.row.campaign_id"
            :required="true"
            @input="toggleModified(props.row)"
          >
            <option
              v-for="campaign in campaigns"
              :key="campaign.id"
              :value="campaign.id"
            >{{campaign.name}}</option>
          </b-select>
        </b-table-column>

        <b-table-column
          meta="Nom du superviseur du Weezy"
          v-if="isAdmin"
          field="supervisor_id"
          label="Superviseur"
          :centered="true"
          :sortable="true"
        >
          <b-select
            :disabled="!isAdmin"
            placeholder="Choisir le Superviseur"
            v-model="props.row.supervisor_id"
            :required="true"
            @input="toggleModified(props.row)"
          >
            <option
              v-for="supervisor in supervisors"
              :key="supervisor.id"
              :value="supervisor.id"
            >{{supervisor.name}} {{supervisor.surname}}</option>
          </b-select>
        </b-table-column>

        <b-table-column
          meta="Led Strip Associée"
          v-if="isAdmin"
          field="stripe_id"
          label="Led Strip"
          :centered="true"
          :sortable="true"
        >
          <b-select
            :disabled="!isAdmin"
            placeholder="Choisir la Led Strip"
            v-model="props.row.stripe_id"
            :required="true"
            @input="toggleModified(props.row)"
          >
            <option
              v-for="stripe in stripes"
              :key="stripe.id"
              :value="stripe.id"
            >{{stripe.id}}</option>
          </b-select>
        </b-table-column>

        <b-table-column
          meta="Vous pouvez réinitialiser des mots de passes mais pas voir ceux existants"
          field="password"
          label="Mot de Passe"
          :centered="true"
          :sortable="true"
        >
          <span class="tag is-primary is-medium">
            <input
              class="b-text-input"
              type="password"
              v-model="props.row.password"
              @input="toggleModified(props.row)"
              placeholder="Choisir un mot de passe"
            >
          </span>
        </b-table-column>

        <b-table-column
          meta="Vous pouvez redémarrer le weezy à distance ici"
          field="password"
          label="Redémarrage"
          :centered="true"
          :sortable="true"
        >
          <button
            v-if="!props.row.require_reboot"
            class="button field is-green is-medium"
            id="clear"
            @click="rebootWeezy(props.row.id)"
          >
            <span>
              <i class="fal fa-power-off"></i> Redémarrer
            </span>
          </button>

          <button
            v-if="props.row.require_reboot"
            class="button field is-danger is-medium"
            id="clear"
            disabled
          >
            <span>
              <i class="fal fa-power-off"></i> Redémarrage en cours...
            </span>
          </button>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas de Weezys</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
export default {
  name: "WeezysTable",
  props: ["weezys", "campaigns", "supervisors", "isAdmin", "stripes"],
  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      modifiedRows: [],
      myData: [],
      storedWeezys: []
    };
  },
  watch: {
    weezys: function(newVal, oldVal) {
      // watch it
      this.myData = this.weezys;
      this.storedWeezys = JSON.parse(JSON.stringify(this.weezys));
      this.isLoading = false;
    }
  },
  methods: {
    rebootWeezy(weezy_id) {
      this.$parent.rebootWeezy(weezy_id);
    },

    toggleModified(raaw) {
      var modified = false;
      // Disallow supervisors / stripe  on multiple weezys
      for (var i = 0; i < this.myData.length; i++) {
        //supervisors
        if (this.myData[i].supervisor_id == raaw.supervisor_id) {
          if (this.myData[i].id != raaw.id) {
            this.myData[i].supervisor_id = null;
          }
        }
        //stripes
        if (this.myData[i].stripe_id == raaw.stripe_id) {
          if (this.myData[i].id != raaw.id) {
            this.myData[i].stripe_id = null;
          }
        }
      }

      this.modifiedRows.push(raaw);
      for (var j = 0; j < this.modifiedRows.length; j++) {
        var row = this.modifiedRows[j];
        for (var i = 0; i < this.storedWeezys.length; i++) {
          var weezy = this.storedWeezys[i];
          if (weezy.id == row.id) {
            if (
              !(
                weezy.name == row.name &&
                weezy.is_active == row.is_active &&
                weezy.campaign_id == row.campaign_id &&
                weezy.supervisor_id == row.supervisor_id &&
                weezy.stripe_id == row.stripe_id &&
                weezy.password != ""
              )
            ) {
              modified = true;
            }
          }
        }
        if (!modified) {
          this.modifiedRows = [];
        }
      }
    },
    validateModifications() {
      this.$parent.modifyRows(this.modifiedRows);
      setTimeout(() => {
        this.modifiedRows = [];
      }, 100);
    },
    cancelModifications() {
      this.$parent.getWeezys();
      setTimeout(() => {
        this.modifiedRows = [];
      }, 100);
    },
    sortByActive(a, b, isAsc) {
      if (isAsc) {
        return b.is_active - a.is_active;
      } else {
        return a.is_active - b.is_active;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* PHONE SIZE */
@media screen and (max-width: 768px) {
  .b-modal-input-number {
    width: 50px;
  }

  .b-input-number {
    width: 50px;
    margin-left: 15px;
  }

  .action-buttons,
  .action-button {
    float: unset;
  }

  .b-table {
    margin-top: 2em;
  }
}

/* DESKTOP SIZE */
@media screen and (min-width: 768px) {
  .b-modal-input-number {
    width: 50px;
  }

  .b-input-number {
    width: 50px;
    margin-left: 15px;
  }

  .b-modal-text-input {
    width: 200px;
    text-align: center;
    background-color: transparent;
    color: #000;
    outline: 1px !important;
  }

  .switch-field {
    width: -webkit-fill-available;
    padding-left: 50px;
  }

  .action-buttons,
  .action-button {
    float: unset !important;
  }

  .tag ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #ddd;
    opacity: 1; /* Firefox */
  }

  .tag :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #ddd;
  }

  .tag ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #ddd;
  }
}

/* DEFAULT CSS */
.goalRow {
  text-align: center;
}

.b-table {
  width: auto;
}

.modal-line {
  display: flex;
  justify-content: space-between;
}
</style>